
import {
  DxDataGrid, DxColumn, DxEditing, DxPaging
} from 'devextreme-vue/data-grid';
import { DxToast } from 'devextreme-vue/toast';
import RoleService from '../services/role-service';

export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxToast,
  },
  data() {
    return {      
      dataSourceRole: null,
      rol: {},
      events: [],
      roleService: null,
      isVisible: false,
      message: '',
      type: 'info',
    };
  },
  created() {
    this.roleService = new RoleService();
  },
  mounted() {    
    this.roleService.getRoles().then(data => this.dataSourceRole=data);
  },
  methods: {
    logEvent(eventName) {
      this.events.unshift(eventName);
    },
    editRole(e) {
			this.roleService.updateRol(e.data).then(() => {
        this.type = 'success';
        this.message = 'Se ha actualizado el registro';
        this.isVisible = true;        
      });
		},
    deleteRole(e) {
			this.roleService.deleteRol(e.data).then(() => {
        this.type = 'success';
        this.message = 'Se ha eliminado el registro';
        this.isVisible = true;
      });
		},
    createRole(e) {
			this.roleService.createRol(e.data).then(() => {
        this.type = 'success';
        this.message = 'Se ha creado el registro';
        this.isVisible = true;
      });
		},
  },
};
